import { createI18n } from "vue-i18n"

export default createI18n({
    locale: 'fa',
    fallbackLocale: 'ar',
    messages: {
        fa: {
            edit: 'ویرایش',
            delete: 'حذف',
            create: 'ثبت',
            link: 'لینک',
            timeLocale: 'fa-IR',
            timeString: 'نوشته شده در {time} مورخ {date}',

            navbar: {
                search: 'جستجو',

                login: 'ورود',
                logout: 'خروج',

                moveUp: 'انتقال به بالا',
                moveDown: 'انتقال به پایین',

                newPage: 'افزودن یک صفحه جدید...',
                delConfirm: 'مطمئنید میخواهید {0} را حذف کنید؟'
            },
            home: {
                glance: {
                    title: 'مختصری از مشکات...',
                    text: `مجتمع حوزوی مشکات، مجموعه‌ای از مدارس و حوزه‌های علمیه است که در راستای تحقق رهنمودهای مقام معظم رهبری و تحول در نظام حوزه‌های علمیه با هدف پرورش طلاب مهذب و کارآمد در حد اجتهاد به منظور تولید و توسعه علوم دینی در جهت نظریه‌پردازی و نظام‌سازی و ارتقای فرهنگ دینی جامعه، از طریق پرورش مبلغان مؤثر و کارآمد در عرصه تبلیغات نوین تأسیس شده است.`,
                },
                news: 'آخرین مطالب',
                more: 'موارد بیشتر',
                calendar: {
                    title: 'تقویم برنامه های مشکات',
                    new: 'رویداد جدید',
                    text: 'متن رویداد'
                },
                students: 'با مشکاتی‌ها',
                edu: 'آموزش و پژوهش',
                schools: {
                    title: 'مدارس مشکات',
                    text: 'مجتمع حوزوی مشکات دارای ۱۰ واحد آموزشی، شامل دو مؤسسه آموزش عالی (سطح چهار حوزه) در شهرهای قم و تهران، دو مدرسه علمیه برادران (مدرسه علی بن موسی الرضا علیهما السلام و مدرسه صدر بازار) و یک مدرسه علمیه خواهران در شهر تهران، دو مدرسه علمیه برادران (مدرسه کریمه اهل بیت سلام الله علیها و مدرسه امام جواد علیه السلام) و یک مدرسه علمیه خواهران در شهر قم، و نیز دو مدرسه علمیه امام کاظم علیه السلام و امام صادق علیه السلام در شهرهای اصفهان و کرمانشاه است.'
                },
                statistics: {
                    title: 'مشکات از نگاه آمار',
                    schools: 'مدارس و مراکز تخصصی',
                    students: 'طلاب سطح',
                    highEdu: 'طلاب مؤسسه آموزش عالی',
                    women: 'خواهران طلبه'
                },
                international: 'ارتباطات و بین‌الملل'
            },
            schools: {
                title: "اخبار {school}"
            },
            footer: {
                links: {
                    imam: 'پرتال امام خمینی (ره)',
                    leader: 'پرتال مقام معظم رهبری',
                    ismc: 'پایگاه اطلاع رسانی مرکز مدیریت حوزه‌های علمیه',
                    whc: 'پایگاه اطلاع رسانی مرکز مدیریت حوزه‌های علمیه خواهران',
                    hNews: 'خبرگزاری رسمی حوزه',
                    csis: 'مرکز خدمات حوزه',
                    miu: 'جامعةالمصطفی (ص) العالمیة'
                },
                addresses: {
                    title: 'راه‌های ارتباطی',
                    address: {
                        title: 'نشانی مدیریت و ستاد مجتمع حوزوی مشکات:',
                        address: 'قم، بلوار جمهوری اسلامی، جنب موسسه آموزشی و پژوهشی امام خمینی(ره)، پلاک ۵'
                    },
                    telephone: {
                        title: 'تلفن:',
                        number: {
                            first: '۰۲۵-۳۲۴۰۰۲۰۴',
                            second: '۰۲۵-۳۲۴۰۰۲۰۵',
                            third: '۰۲۵-۳۲۴۰۰۲۰۶'
                        }
                    },
                    postalCode: {
                        title: 'کد پستی:',
                        code: '۳۷۱۶۶-۸۵۵۳۴'
                    },
                    eMail: {
                        title: 'ایمیل:',
                        address: 'info{\'@\'}howzehmeshkat.ir'
                    }
                },
                socials: 'شبکه‌های اجتماعی',
                copyright: 'تمامی حقوق برای حوزه علمیه مشکوة محفوظ است {\'|\'} {year} ©'
            },
            visitNews: {
                gallery: 'چندرسانه‌ای',
                newPic: 'افزودن تصویر',
                vin: 'خبر ویژه',
                galleryNews: 'خبر تصویری',
                summary: 'چکیده: '
            },
            news: {
                archive: 'آرشیو مطالب',
                results: 'نتایج جستجوی',
                more: 'دریافت اخبار بیشتر...',
                newNews: 'ثبت خبر جدید',
                editNews: 'ویرایش خبر'
            },
            login: {
                title: 'ورود به حساب کاربری',
                username: 'نام کاربری',
                password: 'رمز عبور',
                captcha: 'کلمه امنیتی مقابل',
            }
        },
        ar: {
            edit: 'التعدیل',
            delete: 'الحذف',
            create: 'التسجیل',
            link: 'الرابط',
            timeLocale: 'ar-SA',
            timeString: 'المکتوب في {time} بتأریخ {date}',

            navbar: {
                search: 'البحث',

                login: 'الدخول',
                logout: 'الخروج',

                moveUp: 'تحرك للأعلى',
                moveDown: 'تحرك للأسفل',

                newPage: 'إضافة صفحة جدیدة..',
                delConfirm: 'هل أنت متأكد أنك تريد حذف {0}؟'
            },
            home: {
                glance: {
                    title: 'حوزة مشکاة، بالإختصار ',
                    text: `مجمّع مشکاة الحوزوي، هو مجموعة من الحوزات والمراكز العلميّة التي تأسست بتوجيهٍ واهتمامٍ مباشرٍ من قبل ولي أمر المسلمين سماحة السيد القائد علي الخامنئي (حفظه الله تعالى)، وذلك من أجل إيجاد التحوّل والتغيير في مسار النظام الحوزوي. و یتابع تحقیق أهداف ثلاثة و هي:
اولاً: تربية المحقّقين والفضلاء والوصول بهم إلى مرحلة الاجتهاد، وذلك بهدف إحياء ونشر العلوم الدينيّة، وبالأخص على صعيدي العلوم الإنسانيّة والإسلاميّة.
ثانیا: ارتقاء الوعي والثقافة الدينيّة في المجتمع الإسلامي من خلال تربية وإعداد العلماء والأساتذة والمبلّغين.
ثالثا: إعداد مدراء أفاضل من أجل المساهمة في تلبية احتياجات الحوزة العلميّة والنظام.`
                },
                news: 'الأخبار',
                more: 'الموارد الإضافیة',
                calendar: {
                    title: 'تقویم برامج مشکاة',
                    new: 'الجدید من الأحداث',
                    text: 'الحدث',
                },
                students: 'المشکاتیّون',
                edu: 'قسم التعلیم و الدراسة',
                schools: {
                    title: 'مدارس مشکاة',
                    text: 'تضمّن مجمّع مشکاة الحوزوي عشرة مراکز تعليمية، الشاملة علی مؤسستين للتعليم العالي (المستوى/السطح الرابع الحوزوي) في مدينتي قم وطهران، ومدرستين علميتين للذكور (مدرسة علي بن موسى الرضا عليه السلام ومدرسة صدر بازار) ومدرسة علمية واحدة للإناث في مدينة طهران، ومدرستين علميتين للذكور (مدرسة كريمة أهل البيت سلام الله عليها ومدرسة الإمام جواد عليه السلام) ومدرسة علمية واحدة للإناث في مدينة قم، إضافة إلي مدرستين علميتين الإمام الكاظم عليه السلام والإمام الصادق عليه السلام في مدينتي اصفهان و کرمانشاه.'
                },
                statistics: {
                    title: 'الإحصائیات و التقاریر',
                    schools: 'المدارس و المؤسسات التخصصیة',
                    students: 'طلاب السطوح',
                    highEdu: 'طلاب مؤسسة التعلیم العالی',
                    women: 'الطالبات'
                },
                international: 'العلاقات العامة و العلاقات الدولیة'
            },
            schools: {
                title: 'الأخبار {school}'
            },
            footer: {
                links: {
                    imam: 'موقع الإمام الخمیني',
                    leader: 'موقع الإمام الخامنئه‌اي',
                    ismc: 'موقع مدیریة الحوزة العلمیة ',
                    whc: 'موقع مدیریة الحوزة للأخوات',
                    hNews: 'وکالةأنباء الحوزة',
                    csis: 'الخدمات للحوزة',
                    miu: 'جامعةالمصطفی (ص) العالمیة'
                },
                addresses: {
                    title: 'طرق التواصل',
                    address: {
                        title: 'مجمّع مشکاةالحوزوية (مشكاة) المركز الرئيسي: العنوان:',
                        address: 'قم المقدسة، جسر جمهورى اسلامى، جانب مؤسسة الإمام الخميني (رض)، پلاك ٥'
                    },
                    telephone: {
                        title: 'الهاتف:',
                        number: {
                            first: '٣٢٤٠٠٢٠٤-٠٢٥',
                            second: '٣٢٤٠٠٢٠٥-٠٢٥',
                            third: '٣٢٤٠٠٢٠٦-٠٢٥'
                        }
                    },
                    postalCode: {
                        title: 'الرمز البريدي:',
                        code: '٨٥٥٣٤-٣٧١٦٦'
                    },
                    eMail: {
                        title: 'البرید الإلکتروني:',
                        address: 'info{\'@\'}howzehmeshkat.ir'
                    }
                },
                socials: 'مواقع التواصل الإجتماعي',
                copyright: 'جميع الحقوق محفوظة لدى حوزة المشكاة العلميّة {\'|\'} {year} ©'
            },
            visitNews: {
                gallery: 'معرض الصور والفيديو',
                newPic: 'صورة جديدة',
                vin: 'الأخبار الخاصة',
                galleryNews: 'الصورة تحکي',
                summary: 'الخلاصة: '
            },
            news: {
                archive: 'أرشیف الأخبار',
                results: 'نتائج البحث عن',
                more: 'تلقّي الأخبار الزائدة..',
                newNews: 'إنشاء خبرا جدیدا',
                editNews: 'التسجیل الخبر'
            },
            login: {
                title: 'تسجیل الدخول',
                username: 'اسم المستخدم',
                password: 'رمز المرور',
                captcha: 'رمز التحقق',
            }
        }
    },
    legacy: false
})